export const STEPS = ['user', 'endereco', 'empresa', 'bancaria'] as const;
